var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickertrends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M0.000 29.515 L 0.000 59.029 170.485 59.029 L 340.971 59.029 340.971 229.515 L 340.971 400.000 370.485 400.000 L 400.000 400.000 400.000 200.000 L 400.000 0.000 200.000 0.000 L 0.000 0.000 0.000 29.515 M253.592 247.379 L 253.592 400.000 283.301 400.000 L 313.010 400.000 313.010 247.379 L 313.010 94.757 283.301 94.757 L 253.592 94.757 253.592 247.379 M0.000 287.184 L 0.000 400.000 29.515 400.000 L 59.029 400.000 59.029 287.184 L 59.029 174.369 29.515 174.369 L 0.000 174.369 0.000 287.184 M168.932 315.340 L 168.932 400.000 198.641 400.000 L 228.350 400.000 228.350 315.340 L 228.350 230.680 198.641 230.680 L 168.932 230.680 168.932 315.340 M84.272 343.495 L 84.272 400.000 113.981 400.000 L 143.689 400.000 143.689 343.495 L 143.689 286.990 113.981 286.990 L 84.272 286.990 84.272 343.495 ",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickertrends);
export default __webpack_public_path__ + "static/media/tickertrends.2a0b8f21c910b3f761e09b327e725fe9.svg";
export { ForwardRef as ReactComponent };